import React, { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import "./Donacije.css";
import { useTranslation } from "react-i18next";

const Donacije = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [amount, setAmount] = useState(10); // Default to 10€
  const { t, i18n } = useTranslation();

  const documentUrl = '/docs/VzorecPogodbe.docx';
  const imageUrl = '/docs/vzorec.png';

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 500);
  }, []);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const calculateLength = (lines) => {
    return new TextEncoder().encode(lines.join("\n")).length;
  };

  const formatAmount = (eur) => {
    const cents = Math.round(eur * 100);
    return cents.toString().padStart(15, "0");
  };

  const dateStr = formatDate(new Date());

  const qrLines = [
    "UPNQR",
    "",                        // Payer IBAN
    "X",
    "",
    "",                        // Payer reference
    "",                        // Payer name
    "",                        // Payer address
    "",                        // Payer city
    formatAmount(amount),      // Donation amount in cents (padded)
    dateStr,                   // Payment date
    "X",                       // Urgent
    "CHAR",                    // Purpose code
    "Donacija",                // Purpose message
    dateStr,                   // Payment deadline
    "SI56040010048731043",     // Recipient IBAN
    "SI00202504",              // Reference
    "ROTARY CLUB ŽALEC",       // Recipient name
    "Rimska cesta 98A",        // Recipient address
    "3311 Šempeter v Savinjski dolini"
  ];

  const totalLength = calculateLength(qrLines);
  const upnQrValue = [...qrLines, totalLength.toString()].join("\n");

  const donationOptions = [10, 20, 50, 100];

  return (
    <div className="donacijecelkontejner">
      <div className={`donation-container ${isVisible ? "reveal" : ""}`}>
        <img
          src="/Slike/Rotary2.webp"
          alt="Rotary Club Žalec"
          className="rotary-logo"
        />
        <p>{t('donation_event_count')}</p>
        <div className="donation-display">
           <img
           src={t("donationImage")}
            alt={t("donation_amount_image_alt")}
           className="donation-amount-image"
         />
        </div>
        <div className="qr-section">
          <h3>{t('support_our_work')}</h3>
          <p className="qr-title">{t('choose_donation_amount')}</p>

          <div style={{ marginBottom: "1em" }}>
            {donationOptions.map((val) => (
              <button
                key={val}
                onClick={() => setAmount(val)}
                style={{
                  margin: "0.2em",
                  padding: "0.4em 1.2em",
                  backgroundColor: val === amount ? "#007bff" : "#eee",
                  color: val === amount ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "1rem",
                  cursor: "pointer"
                }}
              >
                {val}€
              </button>
            ))}
          </div>
          <div style={{
            backgroundColor: "#ffffff",
            padding: "12px",
            borderRadius: "10px",
            display: "inline-block",
            boxShadow: "0 0 6px rgba(0,0,0,0.15)"
          }}>
            <QRCodeSVG
              value={upnQrValue}
              size={220}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
            />
          </div>
          <p className="qr-title">{t('qr_code_for_amount', { amount })}</p>
        </div>
        <p>{t('donation_step1')}</p>
        <p>{t('donation_step2')}</p>
        <p>{t('donation_step3')}</p>
        <br />
        <div className="osnutki-container">
          <h3>{t('donate_as_company')}</h3>
          <img src={imageUrl} alt="Predogled dokumenta" className="doc-image" />
          <h5 className="donacijetitle">{t('donation_contract_sample')}</h5>
          <div className="doc-placeholder">
            <p>{t('download_contract_instruction')}</p>
          </div>
          <a href={documentUrl} download className="download-button">
            {t('download_button')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Donacije;